// utils/formatDate.js
export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate().toString().padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
  
    // Format the time
    let hours = date.getHours();
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let ampm = "AM";
    
    if (hours >= 12) {
      ampm = "PM";
      if (hours > 12) hours -= 12; // Convert to 12-hour format
    }
  
    if (hours === 0) hours = 12; // Midnight case
    if (hours === 12) ampm = "PM"; // Noon case
  
    // Format the full date and time string
    return `${day} ${month}, ${year} ${hours}:${minutes} ${ampm}`;
  };
  